<template>
  <section class="post-index__wrapper">
    <div class="post-index__tabs">
      <a class="btn  btn-link" :href="storiesLink">
        Stories
      </a>
      <span class="btn btn-tab">
        Events
      </span>
    </div>
    <div class="post-index" id="post-index">
      <div class="post-index__filters dont-print">
        <div v-if="filters" class="post-index__heading">
          <h2>Filters</h2>
          <button
            class="mobile-only"
            id="post-index__filters__accordion-btn"
            aria-label="Tap to toggle filters"
            aria-controls="post-index__dropdowns"
            aria-expanded="false"
            @click="toggleAccordion"
          ></button>
        </div>
        <div
          v-if="filters"
          class="post-index__dropdowns"
          id="post-index__dropdowns"
        >
          <dropdown
            v-if="filters.themes"
            @changed="setTheme"
            :default-selection="setDropdownValue('theme', 'Campaign Theme')"
          >
            <li
              v-for="theme in filters.themes"
              :key="theme.value"
              :data-value="theme.value"
              class="dropdown-option"
            >
              {{ theme.text }}
            </li>
          </dropdown>
          <dropdown
            v-if="filters.interests"
            @changed="setInterest"
            :default-selection="
              setDropdownValue('interest', 'Areas of Interest')
            "
          >
            <li
              v-for="interest in filters.interests"
              :key="interest.value"
              :data-value="interest.value"
              class="dropdown-option"
            >
              {{ interest.text }}
            </li>
          </dropdown>
          <dropdown
            v-if="filters.schools"
            @changed="setSchool"
            :default-selection="setDropdownValue('school', 'Schools and Units')"
          >
            <li
              v-for="school in filters.schools"
              :key="school.value"
              :data-value="school.value"
              class="dropdown-option"
            >
              {{ school.text }}
            </li>
          </dropdown>
          <dropdown
            v-if="filters.locations"
            @changed="setLocation"
            :default-selection="setDropdownValue('location', 'Location')"
          >
            <li
              v-for="location in filters.locations"
              :key="location.value"
              :data-value="location.value"
              class="dropdown-option"
            >
              {{ location.text }}
            </li>
          </dropdown>
          <a
            class="btn base-btn-primary base-btn-primary--dark"
            :href="currentURL"
            @click="getFilterUrl"
            >Apply</a
          >
          <a
            class="cta base-btn-primary base-btn-primary--dark"
            :href="clearFilters()"
            >Clear Filters</a
          >
        </div>
        <div v-if="tags" class="post-index__tags__wrapper">
          <div class="post-index__heading">
            <h2>Topic Tags</h2>
            <button
              class="mobile-only"
              id="post-index__tags__accordion-btn"
              aria-label="Tap to toggle tags"
              aria-controls="post-index__tags"
              aria-expanded="false"
              @click="toggleAccordion"
            ></button>
          </div>
          <div class="post-index__tags" id="post-index__tags" ref="tags">
            <a
              v-for="tag in tags"
              :key="tag.value"
              :class="
                `cta base-btn-primary base-btn-primary--dark ${setSelectedTag(
                  tag.value
                )}`
              "
              :href="currentURL"
              @click="getTagUrl($event, tag.value)"
              :data-value="tag.value"
            >
              {{ tag.text }}
            </a>
          </div>
        </div>
      </div>
      <div v-if="posts" class="post-index__posts">
        <div class="mobile-only post-index__heading">
          <h2>Results</h2>
        </div>
        <div
          v-for="i in postsEnd - postsStart + 1"
          :key="i"
          class="post-index__post"
        >
          <a class="post-index__post__image" :href="getPost(i - 1).link.href">
            <div class="background__image">
              <picture>
                <source
                  v-if="getPost(i - 1).image.mobileSrc"
                  :srcset="getPost(i - 1).image.mobileSrc"
                  media="(max-width: 639px)"
                />
                <img
                  :src="getPost(i - 1).image.src"
                  :alt="getPost(i - 1).image.alt"
                  class="background__image-img"
                />
              </picture>
            </div>
          </a>
          <div class="base-lockup base-lockup--dark base-lockup--left">
            <p class="base-lockup__kicker">
              {{ getPost(i - 1).date }}
              <span>|</span>
              {{ getPost(i - 1).category }}
            </p>
            <h2 class="base-lockup__heading">
              <a :href="getPost(i - 1).link.href">
                {{ getPost(i - 1).heading }}
              </a>
            </h2>
            <p class="base-lockup__copy base-lockup__copy--regular">
              {{ getPost(i - 1).copy }}
            </p>
            <div class="post-index__post__bottom">
              <div class="base-lockup__ctas">
                <a
                  class="cta base-btn-primary base-btn-primary--dark"
                  :href="getPost(i - 1).link.href"
                >
                  {{ getPost(i - 1).link.text }}
                </a>
              </div>
              <p class="post-index__post__tags">
                <span v-for="tag in getPost(i - 1).tags" :key="tag">
                  {{ tag }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <post-pagination :results="filteredPosts.length"></post-pagination>
  </section>
</template>

<script>
import jQuery from 'jquery'

export default {
  data() {
    return {
      params: Object,
      pageNum: 1,
      postsStart: 1,
      postsEnd: 7,
      filteredPosts: [],
      filterData: Object,
      currentURL: Array,
    }
  },
  props: {
    filters: {
      type: Object,
    },
    tags: {
      type: Array,
    },
    posts: {
      type: Array,
    },
    storiesLink: {
      type: String,
    },
  },
  created() {
    this.params = new URLSearchParams(window.location.search.substring(1))
    this.currentURL = new URL(window.location)
    this.filterData = {
      theme: this.params.get('themes'),
      interest: this.params.get('interests'),
      school: this.params.get('schools'),
      location: this.params.get('locations'),
    }
    this.applyFilters()
    // get the result starting, ending numbers
    if (this.params.get('page')) {
      this.pageNum = this.params.get('page')
      this.pageNum = Number(this.pageNum)
    }
    if (this.pageNum == 1) {
      this.postsStart = 1
      this.postsEnd = 7
    } else {
      this.postsStart = (this.pageNum - 1) * 7 + 1
      this.postsEnd = this.pageNum * 7
    }
    if (this.postsEnd > this.filteredPosts.length) {
      this.postsEnd = this.filteredPosts.length
    }
  },

  methods: {
    setTheme(theme) {
      this.filterData.theme = theme
    },

    setInterest(interest) {
      this.filterData.interest = interest
    },

    setSchool(school) {
      this.filterData.school = school
    },

    setLocation(location) {
      this.filterData.location = location
    },

    toggleAccordion(e) {
      var expanded =
        e.target.getAttribute('aria-expanded') == 'true' ? true : false
      e.target.setAttribute('aria-expanded', !expanded)
      jQuery('#' + e.target.getAttribute('aria-controls')).slideToggle()
    },

    applyFilters() {
      var theme = this.params.get('theme')
      var interest = this.params.get('interest')
      var school = this.params.get('school')
      var location = this.params.get('location')
      var tag = this.params.get('tag')
      // show all if no filters
      if (
        [theme, interest, school, location, tag].every(filter => filter == null)
      ) {
        this.filteredPosts = this.filteredPosts.concat(this.posts)
        return
      }
      this.applyFilter(theme, 'themes')
      this.applyFilter(interest, 'interests')
      this.applyFilter(school, 'schools')
      this.applyFilter(location, 'locations')
      if (tag) {
        this.filteredPosts = this.filteredPosts.concat(
          this.posts.filter(post => post.tags && post.tags.includes(tag))
        )
      }
    },

    applyFilter(value, name) {
      if (value) {
        // check if filter value is in post's data array,
        // and concatenate those posts to filtered posts
        this.filteredPosts = this.filteredPosts.concat(
          this.posts.filter(post => post[name] && post[name].includes(value))
        )
      }
    },

    clearFilters() {
      // return url without query string
      return this.currentURL.href.split('?')[0]
    },

    getFilterUrl(event) {
      event.preventDefault()
      if (this.filterData.theme)
        this.currentURL.searchParams.set('theme', this.filterData.theme)
      if (this.filterData.interest)
        this.currentURL.searchParams.set('interest', this.filterData.interest)
      if (this.filterData.school)
        this.currentURL.searchParams.set('school', this.filterData.school)
      if (this.filterData.location)
        this.currentURL.searchParams.set('location', this.filterData.location)
      this.currentURL.searchParams.set('page', 1)
      window.location.href = this.currentURL
    },

    getTagUrl(event, tag) {
      event.preventDefault()
      this.currentURL.searchParams.set('tag', tag)
      this.currentURL.searchParams.set('page', 1)
      window.location.href = this.currentURL
    },

    setSelectedTag(tag) {
      return tag == this.params.get('tag') ? 'selected' : ''
    },

    setDropdownValue(value, defaultText = '') {
      var param = this.params.get(value)
      // find object with value if exists and display its text content
      var option = this.filters[`${value}s`]
        ? this.filters[`${value}s`].find(filter => filter.value == param)
        : null
      var content = option ? option.text : param
      var ret = {
        value: param ? param : '',
        text: content ? content : defaultText,
      }
      return ret
    },

    getPost(i) {
      let num = this.postsStart + i - 1
      return this.filteredPosts[num]
    },
  },
}
</script>
